import { decodeToken, getIdTokenLocalStorage } from '@sbgsports/vault-sso-auth';
import _ from 'lodash';
import {
  IUser,
  IUserOrg,
  getProductsByOrgId,
} from '../api/idm';
import { IUserRole, IUserInfoVaultRole } from '../state/user/userOrgRole';
import { getUserPermissions } from '../api/vault/userPermissions';

export const getUserEmail = (): string => {
  const token = getIdTokenLocalStorage();
  const { email } = decodeToken(token);
  return email;
};

export const getUserInfo = (users: Array<IUser>) => {
  const userEmail = getUserEmail();
  const userInfo = users.find((user) => user.email === userEmail);
  return userInfo;
};

export const getUserRoleOfVault = (userOrgs: Array<IUserOrg>): Array<IUserRole> => {
  let userVaultRoles: Array<IUserRole> = [];

  userOrgs.forEach((userOrg) => {
    const role = {
      orgId: userOrg.orgId,
      orgName: userOrg.org.name,
      roleId: userOrg.roleId,
      roleName: userOrg.role.name,
    };
    userVaultRoles = [...userVaultRoles, role];
  });

  return userVaultRoles;
};

export const getUserInfoAndRoleOfVault = (user: IUser, userOrgs: Array<IUserOrg>): IUserInfoVaultRole => {
  const userInfo = {
    userId: user.id,
    email: user.email,
    userName: user.userName,
    displayName: user.displayName,
    firstName: user.firstName,
    lastName: user.lastName,
  };
  const userVaultRoles = getUserRoleOfVault(userOrgs);
  return {
    userInfo,
    userVaultRoles,
  };
};

export const getProductNamesByOrgId = async (orgIds: number[]) => {
  const results = await Promise.all(orgIds.map((orgId) => getProductsByOrgId(orgId)));
  // note: getting available products from idm, filtering by status, mapping by name, and flattening for use
  return _.uniq(results
    .filter(({ status }) => status === 200)
    .map(({ data: { data } }) => data)
    .flat()
    .map(({ name }) => name));
};

export const getUserAccessPermission = async (user: IUserInfoVaultRole): Promise<object> => {
  const userPermissions = (await getUserPermissions()).data.data;
  return userPermissions;
};
